import { SearchPeopleRequest, SearchPeopleResultExternal } from '@askporter/client-grieg-lyric';
import { API } from '../../../api';

export default async ({ search }: { search: SearchPeopleRequest }): Promise<SearchPeopleResultExternal> => {
  const payload = search as SearchPeopleRequest;

  const { data } = await API().post({ path: `people/search`, payload });
  return data;
};
